import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const TagInput = ({name, label, options, isLoading, isSubmitting, load, ...props}) => {

  // load tags on mount
  useEffect(() => {
    load();
  }, [load]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label ? label : t('journal_post_tags')}
          rules={[
            {required: true, message: t('feedback_validation_required')},
          ]}
        >
          <Select
            mode="tags"
            disabled={isLoading || isSubmitting}
            loading={isLoading}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default TagInput;
